import { render, staticRenderFns } from "./ChartPieIcon.vue?vue&type=template&id=4bb72517&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb72517",
  null
  
)

export default component.exports